import { combineReducers } from "redux";
import { USERS_FETCHED } from "../types";

const byId = (state = {}, action) => {
  switch (action.type) {
    case USERS_FETCHED:
      return {
        ...state,
        ...action.payload.entities.users
      };
    default:
      return state;
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case USERS_FETCHED: {
      return action.payload.result;
    }
    default:
      return state;
  }
};

const container = (state = [], action) => {
  switch (action.type) {
    case "GET_USERS":
      return action.payload.users;
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds, container });



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js